<template>
    <div class="af" >
        <el-table
                border
                :data="dialogOptions"
                ref="subTable"
                size="mini"
                :height="tableHeight"
                :row-key="getRowKeys"
                @select-all="allchoose"
                @select="onSelectionChange"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
        >
            <el-table-column
                align="left"
                type="selection"
                :reserve-selection="true"
                width="55">
            </el-table-column>
            <el-table-column
                    v-if="i_isfrom==1"
                    prop="vc_fppzname"
                    :label="$t('invoiceEntry_invoice_item_name')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <!--<el-tooltip class="item" effect="dark" :content="scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs" placement="top">
                        <div class="fppm" >{{scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs}}</div>
                    </el-tooltip>-->
                    <span class="fppm">{{scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary"  :class="baseerp+'btn'" size="mini" @click="confirmSplit">{{$t('button_confirm')}}</el-button>
            <el-button size="mini" @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {},
        props: {
            Data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {

                dialogOptions: [],
                dialogSelected: [],
                getRowKeys(row){
                    return row.vc_fkey_sub
                },
                i_isfrom:1,
                i_fytype:0,
                i_flag:0,
                flagpzList:[],
                details_form:{},
                baseerp: "",
                file_url: '',
                file_root:"",
                baseApp:"",
                baseVersion:"",
                mid: 0,
                showTable:true,
                loading:false,
                tableData: [],
                mainRow:{},
                tableHeight:300,
            }
        },
        mounted() {
            //console.log("Data", this.Data)
            //this.tableData=this.Data.data;
            //this.mainRow=this.Data.row;
            this.tableData = this.deepClone(this.Data.data);
            this.mainRow = this.deepClone(this.Data.row);
            //console.log('mainRow', this.mainRow.f_pay_ws);

            /*console.log(
                'selected children',
                this.tableData.filter(
                    item => item.vc_hs_fkey_sub === this.mainRow.vc_fkey_sub
                )
            );
            console.log(
                'originalWs',
                this.getOriginalWs(this.mainRow)
            );*/
            this.prepareDialog();
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            /*console.log("Data", this.Data);
            this.tableData=this.Data.data;
            this.pickdata=this.Data.pickone;
            this.i_isfrom=this.Data.i_isfrom;
            this.i_fytype=this.Data.i_fytype;
            this.i_flag=this.Data.i_flag;
            this.flagpzList=this.Data.flagpzList;
            this.details_form=this.Data.details_form;
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file_root = file_root;
            this.file=this.file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');*/
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
            //mainTableBody.removeEventListener('scroll', this.syncTableScroll))
        },
        methods: {
            updateTableHeight() {
                //console.log(this.dataOrd.maxDialogHeight,'this.dataOrd.maxDialogHeight');
                const dialogHeight = this.Data.maxDialogHeight ; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight = 350;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight=dialogHeight;
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            prepareDialog() {
                const mainKey = this.mainRow.vc_fkey_sub;

                const existingMainKeysWithChildren = this.tableData
                    .filter(item => item.i_type === 0 && item.vc_hs_fkey_sub)
                    .map(item => item.vc_hs_fkey_sub);
                //console.log(existingMainKeysWithChildren,'existingMainKeysWithChildren')
                this.dialogOptions = this.tableData.filter(item => {
                    const isSelf = item.vc_fkey_sub === mainKey;
                    const isOtherSub = item.i_type === 0 && item.vc_hs_fkey_sub !== mainKey;
                    const isAlreadyUsedAsMain = existingMainKeysWithChildren.includes(item.vc_fkey_sub);
                    const hasDetails = item.i_type ==1 && item.details && item.details.length > 0;
                    return !isSelf && !isOtherSub && !isAlreadyUsedAsMain  && !hasDetails;
                });
                //console.log(this.dialogOptions,'this.dialogOptions')
                const alreadySelected = this.tableData.filter(
                    item => item.i_type === 0 && item.vc_hs_fkey_sub === mainKey
                );
                this.dialogSelected = alreadySelected.map(item => item.vc_fkey_sub);

                this.$nextTick(() => {
                    this.dialogOptions.forEach(row => {
                        if (this.dialogSelected.includes(row.vc_fkey_sub)) {
                            this.$refs.subTable.toggleRowSelection(row, true);
                        }
                    });
                    this.updateTableHeight();
                    window.removeEventListener('resize', this.updateTableHeight);
                    window.addEventListener('resize', this.updateTableHeight);
                });
            },
            onSelectionChange(val) {
                this.dialogSelected = Array.isArray(val) ? val.map(i => i.vc_fkey_sub) : [];
            },
            confirmSplit() {
                //const updatedList = [...this.tableData];
                const updatedList = this.deepClone(this.tableData);
                const mainKey = this.mainRow.vc_fkey_sub;

                // 清空原来的子项关系
                updatedList.forEach(item => {
                    if (item.vc_hs_fkey_sub === mainKey) {
                        item.i_type = 1;
                        item.vc_hs_fkey_sub = '';
                    }
                });

                // 设置新的子项关系
                const newSubItems = updatedList.filter(item =>
                    this.dialogSelected.includes(item.vc_fkey_sub)
                );

                newSubItems.forEach(item => {
                    item.i_type = 0;
                    item.vc_hs_fkey_sub = mainKey;
                });

                const originalWs = this.getOriginalWs(this.mainRow);
                const originalZzs = this.getOriginalZzs(this.mainRow);

                const wsSum = newSubItems.reduce(
                    (sum, i) => sum + Number(i.f_pay_ws || 0),
                    0
                );

                const zzsSum = newSubItems.reduce(
                    (sum, i) => sum + Number(i.f_pay_zzs || 0),
                    0
                );

                const newPayWs = originalWs + wsSum;
                const newPayZzs = originalZzs + zzsSum;
                const newPriceWs = this.preciseDiv(
                    newPayWs,
                    this.mainRow.f_fpnum
                );

                // 当前页面显示对象
                this.mainRow.f_pay_ws = newPayWs;
                this.mainRow.f_pay_zzs = newPayZzs;
                this.mainRow.f_price_ws = newPriceWs;
                //console.log('this.mainRow.f_pay_ws',this.mainRow.f_pay_ws)
                //console.log('this.mainRow.f_pay_zzs',this.mainRow.f_pay_zzs)
                //console.log('this.mainRow.f_price_ws',this.mainRow.f_price_ws)
                //console.log('this.mainRow.i_isSplit',this.mainRow.i_isSplit)
                // 同步写回列表中的主记录
                const targetRow = updatedList.find(
                    item => item.vc_fkey_sub === mainKey
                );

                if (targetRow) {
                    targetRow.f_pay_ws = parseFloat(this.keepTwoDecimal(newPayWs)) ;
                    targetRow.f_pay_zzs = parseFloat(this.keepTwoDecimal(newPayZzs)) ;
                    targetRow.f_pay = parseFloat(this.keepTwoDecimal(newPayWs+newPayZzs)) ;
                    targetRow.f_price_ws = newPriceWs;
                    //targetRow.details = [];
                   //targetRow.i_isSplit = 1;
                    targetRow.i_isSplit = newSubItems.length > 0 ? 1 : 0;
                }
                this.$emit('confirm', updatedList, this.Data.index);

                this.cancel();
            },
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            /*confirmSplit() {
                const updatedList = [...this.tableData];
                const mainKey = this.mainRow.vc_fkey_sub;

                updatedList.forEach(item => {
                    if (item.vc_hs_fkey_sub === mainKey) {
                        item.i_type = 1;
                        item.vc_hs_fkey_sub = '';
                    }
                });

                const newSubItems = updatedList.filter(item =>
                    this.dialogSelected.includes(item.vc_fkey_sub)
                );
                newSubItems.forEach(item => {
                    item.i_type = 0;
                    item.vc_hs_fkey_sub = mainKey;
                });

                const originalWs = this.getOriginalWs(this.mainRow);
                const originalZzs = this.getOriginalZzs(this.mainRow);
                const wsSum = newSubItems.reduce((sum, i) => sum + Number(i.f_pay_ws || 0), 0);
                const zzsSum = newSubItems.reduce((sum, i) => sum + Number(i.f_pay_zzs || 0), 0);

                this.mainRow.f_pay_ws = originalWs + wsSum;
                this.mainRow.f_pay_zzs = originalZzs + zzsSum;
                this.mainRow.f_price_ws = this.preciseDiv(this.mainRow.f_pay_ws, this.mainRow.f_fpnum);
                //console.log(updatedList,'updatedList')
                //console.log(this.mainRow,'this.mainRow')

                this.$emit('confirm', updatedList,this.Data.index);
                this.cancel()
            },*/
            getOriginalWs(row) {
                /*return row._origin_f_pay_ws != null
                    ? row._origin_f_pay_ws
                    : (row._origin_f_pay_ws = Number(row.f_pay_ws || 0));*/

                const childSum = this.tableData
                    .filter(item =>
                        item.i_type === 0 &&
                        item.vc_hs_fkey_sub === row.vc_fkey_sub
                    )
                    .reduce(
                        (sum, item) =>
                            sum + Number(item.f_pay_ws || 0),
                        0
                    );

                return Number(row.f_pay_ws || 0) - childSum;
            },
            getOriginalZzs(row) {
                /*return row._origin_f_pay_zzs != null
                    ? row._origin_f_pay_zzs
                    : (row._origin_f_pay_zzs = Number(row.f_pay_zzs || 0));*/
                const childSum = this.tableData
                    .filter(item =>
                        item.i_type === 0 &&
                        item.vc_hs_fkey_sub === row.vc_fkey_sub
                    )
                    .reduce(
                        (sum, item) =>
                            sum + Number(item.f_pay_zzs || 0),
                        0
                    );

                return Number(row.f_pay_zzs || 0) - childSum;
            },
            allchoose(val){
                //console.log(val,'val')
                this.dialogSelected = Array.isArray(val) ? val.map(i => i.vc_fkey_sub) : [];
                //console.log(this.dialogSelected,'this.dialogSelected')
            },
            cancel(){
                this.$emit('close')
            },
            //除
            preciseDiv(dividend, divisor) {
                if (dividend && divisor) {
                    //console.log(dividend, "////", divisor);
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    //console.log(result, 'result------')
                    return result;
                }
            },
        },

    }
</script>
<style lang="scss" scoped>

    .af .el-table{
        max-height: 700px;
        overflow-y: auto;
    }
    .fppm{
        width: 100%;
        max-height: 40px; /* 根据需要设置占位的行高 × 行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 显示的行数 */
        -webkit-box-orient: vertical;
    }
</style>